(() => {
  const start = root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const config = JSON.parse(root.querySelector('[data-order-config]').textContent);
    const strings = config.strings;
    const text = (key, values = {}) => Object.entries(values).reduce((s, [k, v]) => s.replaceAll(`[${k}]`, v), strings[Number(values.count) === 1 && strings[key + '_one'] ? key + '_one' : key] || key);
    const money = value => new Intl.NumberFormat(config.locale === 'es' ? 'es-MX' : config.locale, { style: 'currency', currency: config.currency, maximumFractionDigits: 2 }).format(value);
    const path = root.dataset.root.replace(/\/?$/, '/');
    const cards = root.querySelector('[data-order-cards]');
    const form = root.querySelector('[data-order-form]');
    const add = root.querySelector('[data-order-add]');
    const error = root.querySelector('[data-order-error]');
    const reviewed = root.querySelector('[data-reviewed]');
    const editors = new WeakMap();
    let selections;
    const minimum = Number(root.dataset.minimum);
    const blankOnly = root.dataset.blankOnly === 'true';
    const ArtworkPreview = blankOnly ? class extends window.KBArtworkPreview {
      labelAllowed() { return false; }
      canEditSide() { return false; }
    } : window.KBArtworkPreview;
    let cartCount = Number(config.cartCount) || 0;
    let busy = false;
    let uncertain = false;
    let sequence = 0;
    const products = config.products.filter(entry => entry.product && entry.product.id);
    const field = (card, name) => card.querySelector(`[data-${name}]`);
    const kindFor = card => blankOnly ? 'blank' : field(card, 'kind').value;
    const enforceBlankCard = card => {
      if (!blankOnly) return;
      const kind = field(card, 'kind');
      kind.value = 'blank'; kind.disabled = true;
      kind.closest('label').hidden = true;
      [...kind.options].forEach(option => { option.disabled = option.value !== 'blank'; option.hidden = option.value !== 'blank'; });
      const layout = field(card, 'layout');
      layout.value = 'One'; layout.disabled = true; layout.closest('label').hidden = true;
      const notes = field(card, 'notes');
      notes.value = ''; notes.disabled = true; notes.closest('details').hidden = true;
      const editor = editors.get(card);
      for (const side of ['front', 'back', 'label']) {
        const input = field(card, side);
        input.value = ''; input.disabled = true;
        if (editor?.states[side]?.file || editor?.states[side]?.image || editor?.states[side]?.url) editor.setFile(side, null);
      }
      field(card, 'artwork-panel').hidden = true;
      field(card, 'art-adjust').hidden = true;
    };
    const productFor = card => products.find(p => p.handle === `playera-${kindFor(card) === 'custom' ? 'personalizada' : 'sin-estampado'}-${field(card, 'weight').value}g`)?.product;
    const isLargeSize = size => size === '2XL' || size === '3XL';
    const variantFor = (card, size) => {
      if (isLargeSize(size) && field(card, 'weight').value !== '300') return undefined;
      const product = isLargeSize(size) ? config.largeReview?.[kindFor(card)] || config.largeProducts?.[kindFor(card)] || productFor(card) : productFor(card);
      return product?.variants?.find(v => v.option1 === field(card, 'color').value && v.option2 === field(card, 'weight').value + ' g' && v.option3 === size);
    };
    const chosen = card => [...card.querySelectorAll('[data-size]')].map(input => ({ input, quantity: Number(input.value || 0), variant: variantFor(card, input.dataset.size) }));
    const showError = message => { error.textContent = message; error.hidden = !message; };
    const selectable = variant => Boolean(variant?.available || variant?.previewOnly && config.currency === 'MXN');
    const hasReview = () => [...cards.children].some(card => chosen(card).some(row => row.quantity > 0 && row.variant?.previewOnly));
    const countSelection = () => [...cards.children].reduce((n, card) => n + chosen(card).reduce((sum, row) => sum + (Number.isSafeInteger(row.quantity) && row.quantity > 0 ? row.quantity : 0), 0), 0);
    const tierFor = count => count >= 31 ? 3 : count >= 12 ? 2 : count >= 3 ? 1 : 0;
    const update = () => {
      [...cards.children].forEach(enforceBlankCard);
      [...cards.children].forEach(card => chosen(card).forEach(row => { if (isLargeSize(row.input.dataset.size) && !selectable(row.variant)) row.input.value = '0'; }));
      const count = countSelection();
      const tier = tierFor(cartCount + count);
      let total = 0, retail = 0, valid = true;
      [...cards.children].forEach((card, index) => {
        field(card, 'combo-number').textContent = String(index + 1).padStart(2, '0');
        field(card, 'remove').hidden = false;
        const rows = chosen(card);
        const n = rows.reduce((sum, row) => sum + (row.quantity > 0 ? row.quantity : 0), 0);
        const rates = config.rates[kindFor(card)][field(card, 'weight').value];
        const priced = rows.map(row => {
          const original = (row.variant?.price || 0) / 100;
          const unit = !isLargeSize(row.input.dataset.size) && config.currency === 'MXN' && rates && original === rates[0] ? rates[tier] : original;
          return { ...row, original, unit };
        });
        const selected = priced.filter(row => row.quantity > 0);
        const comboTotal = selected.reduce((sum, row) => sum + row.quantity * row.unit, 0);
        const comboRetail = selected.reduce((sum, row) => sum + row.quantity * row.original, 0);
        total += comboTotal; retail += comboRetail;
        const displayed = selected.length ? selected : priced.filter(row => row.variant && !isLargeSize(row.input.dataset.size));
        const priceRange = key => {
          const values = displayed.map(row => row[key]);
          const low = values.length ? Math.min(...values) : 0, high = values.length ? Math.max(...values) : 0;
          return low === high ? money(low) : `${money(low)} – ${money(high)}`;
        };
        rows.forEach(row => {
          row.input.toggleAttribute('data-positive', row.quantity > 0);
          row.input.disabled = busy || !selectable(row.variant);
          window.KBAvailability.size(row.input, window.KBAvailability.state({ color: field(card, 'color').value, weight: field(card, 'weight').value + ' g', large: isLargeSize(row.input.dataset.size), exists: Boolean(row.variant), available: selectable(row.variant) }));
          card.querySelectorAll(`[data-target-size="${row.input.dataset.size}"]`).forEach(button => { button.disabled = row.input.disabled || (Number(button.dataset.step) < 0 ? row.quantity <= 0 : row.quantity >= 999); });
          if (!Number.isSafeInteger(row.quantity) || row.quantity < 0 || row.quantity > 999 || row.quantity > 0 && !selectable(row.variant)) valid = false;
        });
        field(card, 'retail').textContent = priceRange('original');
        field(card, 'retail').hidden = comboTotal >= comboRetail;
        field(card, 'unit').textContent = text('unit', { price: priceRange('unit') });
        field(card, 'combo-total').textContent = `${text('pieces', { count: n })} · ${money(comboTotal)}`;
        field(card, 'large-size-note').hidden = !selected.some(row => isLargeSize(row.input.dataset.size));
        field(card, 'large-review-note').hidden = !selected.some(row => row.variant?.previewOnly);
        const kind = kindFor(card);
        const custom = kind === 'custom';
        field(card, 'production-note').hidden = !custom;
        const labelAllowed = !blankOnly && (custom || kind === 'blank');
        const layout = field(card, 'layout').value;
        editors.get(card)?.sync(kind, field(card, 'color').value, layout, busy);
        field(card, 'artwork-panel').hidden = !labelAllowed;
        field(card, 'art-adjust').hidden = blankOnly || !custom && editors.get(card)?.side !== 'label';
        field(card, 'layout').disabled = busy || !custom;
        for (const side of ['front', 'back', 'label']) {
          const enabled = side === 'label' ? labelAllowed : custom && layout !== (side === 'front' ? 'Back' : 'Front');
          field(card, side).disabled = busy || !enabled;
          card.querySelector(`[data-upload-side="${side}"]`).hidden = !enabled;
          card.querySelector(`[data-file-name="${side}"]`).textContent = field(card, side).files[0]?.name || text('file_empty');
          const button = card.querySelector(`[data-clear="${side}"]`);
          button.toggleAttribute('data-empty', !field(card, side).files.length || !enabled);
          button.disabled = busy || !enabled;
        }
        field(card, 'upload-hint').textContent = text(custom ? 'upload_hint' : 'blank_upload');
        selections?.render(card, { selected, comboTotal, comboRetail, priceRange });
      });
      root.querySelector('[data-total-count]').textContent = text('pieces', { count });
      const originalTotal = root.querySelector('[data-total-retail]');
      if (originalTotal) { originalTotal.hidden = retail <= total; originalTotal.textContent = money(retail); }
      root.querySelector('[data-total-price]').textContent = money(total);
      const regularSelected = [...cards.children].some(card => chosen(card).some(row => row.quantity > 0 && !isLargeSize(row.input.dataset.size)));
      root.querySelector('[data-tier]').textContent = count > 0 && !regularSelected ? text('large_fixed') : text('tier', { count: cartCount + count });
      const savings = root.querySelector('[data-savings]');
      savings.hidden = retail <= total; savings.textContent = text('saving', { price: money(retail - total) });
      root.querySelector('[data-minimum-message]').textContent = count < minimum ? text('missing', { count: minimum - count }) : text('minimum', { count: minimum });
      add.textContent = busy ? text('adding') : count ? text('add', { count }) : text('empty');
      add.disabled = busy || uncertain || count < minimum || !valid || hasReview();
    };
    const syncCard = card => {
      enforceBlankCard(card);
      const kind = kindFor(card);
      const weight = field(card, 'weight');
      const color = field(card, 'color');
      [...weight.options].forEach(option => { option.disabled = !products.some(p => p.handle === `playera-${kind === 'custom' ? 'personalizada' : 'sin-estampado'}-${option.value}g`); });
      if (weight.selectedOptions[0]?.disabled) weight.value = [...weight.options].find(option => !option.disabled)?.value || '';
      [...color.options].forEach(option => { option.disabled = !productFor(card)?.variants.some(v => v.option1 === option.value && v.available); });
      if (color.selectedOptions[0]?.disabled) color.value = [...color.options].find(option => !option.disabled)?.value || '';
      window.KBAvailability.select(weight);
      window.KBAvailability.select(color);
      selections?.remember(card);
      update();
    };
    const newCard = (kind = root.dataset.defaultKind) => {
      const card = root.querySelector('[data-order-template]').content.firstElementChild.cloneNode(true);
      sequence++;
      card.querySelectorAll('input,select,textarea').forEach((input, index) => {
        input.id = `${root.id || 'kb-order'}-${sequence}-${index}`;
        input.closest('label')?.setAttribute('for', input.id);
      });
      field(card, 'kind').value = blankOnly ? 'blank' : kind;
      field(card, 'weight').value = '220';
      if (sequence === 1 && root.dataset.productHandle) {
        const entry = products.find(p => p.handle === root.dataset.productHandle);
        if (entry) { field(card, 'kind').value = entry.handle.includes('sin-estampado') ? 'blank' : 'custom'; field(card, 'weight').value = entry.product.variants[0]?.option2.replace(/\D/g, '') || '220'; }
      }
      enforceBlankCard(card);
      card.addEventListener('input', event => { if (!busy && event.target.matches('[data-size]')) update(); });
      const editor = new ArtworkPreview(card, config); editors.set(card, editor);
      card.querySelectorAll('[data-face]').forEach(button => button.addEventListener('click', () => { if (!busy) update(); }));
      card.addEventListener('change', event => {
        if (busy) return;
        enforceBlankCard(card);
        if (event.target.matches('[data-kind],[data-weight],[data-color]')) {
          const active = selections.change(card, {});
          return;
        }
        const side = event.target.matches('[data-front]') ? 'front' : event.target.matches('[data-back]') ? 'back' : event.target.matches('[data-label]') ? 'label' : null;
        if (side && !blankOnly) {
          const file = event.target.files[0];
          if (file && (!/\.(png|jpe?g|pdf)$/i.test(file.name) || !['image/png', 'image/jpeg', 'application/pdf', ''].includes(file.type) || file.size > 10 * 1024 * 1024 || !file.size)) { event.target.value = ''; editor.setFile(side, null); showError(text('file_invalid')); }
          else { showError(''); editor.setFile(side, file || null); }
        }
        syncCard(card);
      });
      card.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => {
        if (busy) return; const input = card.querySelector(`[data-size="${button.dataset.targetSize}"]`);
        input.value = String(Math.max(0, Math.min(999, (Number(input.value) || 0) + Number(button.dataset.step)))); update();
      }));
      card.querySelectorAll('[data-clear]').forEach(button => button.addEventListener('click', () => { if (!busy) { const side = button.dataset.clear; field(card, side).value = ''; editor.setFile(side, null); update(); } }));
      field(card, 'remove').addEventListener('click', () => selections.remove(card));
      cards.append(card); selections?.attach(card, `${root.id || 'kb-order'}-${sequence}`); syncCard(card);
      return card;
    };
    selections = new window.KBSelectionCards({
      root, cards, field, chosen, create: newCard, sync: syncCard, update, editors, text, money, config, productFor,
      busy: () => busy,
      canChange: card => chosen(card).every(row => !row.quantity || selectable(row.variant)),
      thumbnail: () => null,
      onOpen: card => { if (blankOnly) syncCard(card); }
    });
    root.querySelector('[data-another]').addEventListener('click', () => {
      if (blankOnly) [...cards.children].forEach(syncCard);
      const card = selections.another();
    });
    const refreshCart = async () => {
      const response = await fetch(`${path}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!response.ok) throw new Error(text('error'));
      const cart = await response.json(); cartCount = cart.item_count;
      document.dispatchEvent(new CustomEvent('kb:cart-updated', { detail: cart }));
      update(); return cart;
    };
    const post = async (body, json = false) => {
      let response, data;
      try { response = await fetch(`${path}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json', ...(json ? { 'Content-Type': 'application/json' } : {}) }, body: json ? JSON.stringify(body) : body }); data = await response.json(); }
      catch (_) { uncertain = true; throw new Error(text('network')); }
      if (!response.ok) throw new Error(data.description || data.message || text('error'));
      return data;
    };
    form.addEventListener('keydown', event => {
      if (event.key === 'Enter' && event.target.matches('input,select')) event.preventDefault();
    });
    form.addEventListener('submit', async event => {
      event.preventDefault(); if (busy || uncertain || event.submitter !== add) return;
      if (blankOnly) [...cards.children].forEach(syncCard);
      showError(''); root.querySelector('[data-order-status]').textContent = '';
      if (hasReview()) { showError(text('large_review')); return; }
      const count = countSelection();
      if (count < minimum) { showError(text('missing', { count: minimum - count })); return; }
      const contact = {
        'Contacto nombre': root.querySelector('[data-contact-name]').value.trim(),
        'Contacto teléfono': root.querySelector('[data-contact-phone]').value.trim(),
        'Contacto correo': root.querySelector('[data-contact-email]').value.trim()
      };
      if (contact['Contacto nombre'].length < 2 || contact['Contacto teléfono'].replace(/\D/g, '').length < 7 || !form.reportValidity()) { showError(text('contact_invalid')); return; }
      const batches = [];
      for (const card of cards.children) {
        const rows = chosen(card);
        if (rows.some(row => !Number.isSafeInteger(row.quantity) || row.quantity < 0 || row.quantity > 999)) { showError(text('invalid_quantity')); selections.open(card, true); return; }
        const selected = rows.filter(row => row.quantity > 0);
        if (!selected.length) continue;
        if (selected.some(row => !selectable(row.variant))) { showError(text('unavailable')); selections.open(card, true); return; }
        const custom = kindFor(card) === 'custom';
        const layout = field(card, 'layout').value;
        const front = custom && layout !== 'Back' ? field(card, 'front').files[0] : null;
        const back = custom && layout !== 'Front' ? field(card, 'back').files[0] : null;
        const label = !blankOnly && (custom || kindFor(card) === 'blank') ? field(card, 'label').files[0] : null;
        if (custom && !front && layout !== 'Back') { showError(text('file_required_front')); selections.open(card); field(card, 'front').focus(); return; }
        if (custom && !back && layout !== 'Front') { showError(text('file_required_back')); selections.open(card); field(card, 'back').focus(); return; }
        if ([front, back, label].some(file => file && (!/\.(png|jpe?g|pdf)$/i.test(file.name) || !['image/png', 'image/jpeg', 'application/pdf', ''].includes(file.type) || file.size > 10 * 1024 * 1024 || file.size === 0))) { showError(text('file_invalid')); selections.open(card); field(card, front ? 'front' : back ? 'back' : 'label').focus(); return; }
        const props = { ...contact, '_kb_minimum': String(minimum), [text('properties_type')]: text(custom ? 'custom' : 'blank') };
        if (custom) {
          props[text('properties_layout')] = field(card, 'layout').selectedOptions[0].textContent.trim();
          props['Caras a estampar'] = front && back ? 'Frente y espalda' : front ? 'Sólo frente' : 'Sólo espalda';
        }
        if (!blankOnly && field(card, 'notes').value.trim()) props[text('properties_notes')] = field(card, 'notes').value.trim();
        batches.push({ rows: selected, custom, front, back, label, props, card });
      }
      busy = true;
      form.querySelectorAll('button,input,select,textarea').forEach(el => { el.disabled = true; });
      update();
      let confirmed = 0;
      try {
        for (const batch of batches) if (!blankOnly && (batch.custom || batch.label)) { batch.preview = await editors.get(batch.card).exportFile(); batch.props['_kb_preview_positions'] = editors.get(batch.card).positions(); }
        await refreshCart();
        for (const batch of batches) {
          let props = batch.props;
          let remaining = batch.rows;
          if (!blankOnly && (batch.custom || batch.label)) {
            const first = batch.rows[0];
            const body = new FormData(); body.append('id', first.variant.id); body.append('quantity', first.quantity);
            Object.entries(props).forEach(([key, value]) => body.append(`properties[${key}]`, value));
            if (batch.front) body.append(`properties[${text('properties_front')}]`, batch.front);
            if (batch.back) body.append(`properties[${text('properties_back')}]`, batch.back);
            if (batch.label) body.append(`properties[${text('properties_label')}]`, batch.label);
            body.append('properties[Vista previa (referencia)]', batch.preview);
            const result = await post(body);
            props = result.properties || props;
            first.input.value = '0'; confirmed += first.quantity; remaining = batch.rows.slice(1);
            if (!/^https?:\/\/|^\/\//.test(props['Vista previa (referencia)'] || '')) throw new Error(text('partial'));
            if ((batch.front && !/^https?:\/\/|^\/\//.test(props[text('properties_front')] || '')) || (batch.back && !/^https?:\/\/|^\/\//.test(props[text('properties_back')] || ''))) throw new Error(text('partial'));
            if (batch.label && !/^https?:\/\/|^\/\//.test(props[text('properties_label')] || '')) throw new Error(text('partial'));
          }
          if (remaining.length) {
            await post({ items: remaining.map(row => ({ id: row.variant.id, quantity: row.quantity, properties: props })) }, true);
            remaining.forEach(row => { row.input.value = '0'; confirmed += row.quantity; });
          }
        }
        root.querySelector('[data-order-status]').textContent = text('added');
      } catch (failure) { showError((confirmed && !uncertain ? `${text('partial')} ` : '') + failure.message); }
      finally {
        busy = false; form.querySelectorAll('button,input,select,textarea').forEach(el => { el.disabled = false; });
        if (blankOnly) [...cards.children].forEach(enforceBlankCard);
        reviewed.hidden = !uncertain;
        try { await refreshCart(); } catch (_) { }
        update();
        if (confirmed || uncertain) document.dispatchEvent(new CustomEvent('kb:open-cart'));
      }
    });
    reviewed.addEventListener('click', async () => { try { await refreshCart(); uncertain = false; reviewed.hidden = true; showError(''); update(); } catch (_) { showError(text('error')); } });
    document.addEventListener('kb:cart-updated', event => { cartCount = event.detail.item_count; update(); });
    document.addEventListener('visibilitychange', () => { if (!document.hidden && !busy) refreshCart().catch(() => {}); });
    window.addEventListener('pageshow', () => {
      if (busy) return;
      if (blankOnly) [...cards.children].forEach(syncCard);
      refreshCart().catch(() => {});
    });
    newCard(); refreshCart().catch(() => {});
  };
  document.querySelectorAll('[data-order-builder]').forEach(start);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-order-builder]').forEach(start));
})();

